import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type Ranking {\n    id: String\n    rank: Int\n    meta: MediaMeta\n  }\n\n  type Query {\n    ranking(target: String, range: String, channel: Int, count: Int): [Ranking]\n  }\n"])));
export var resolvers = {
  Query: {
    ranking: function () {
      var _ranking = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var target, range, channel, count, dataSources, res, ranking;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                target = _ref.target, range = _ref.range, channel = _ref.channel, count = _ref.count;
                dataSources = _ref2.dataSources;
                _context.next = 4;
                return dataSources.meta.rankingSearch(channel, target, range, count);

              case 4:
                res = _context.sent;
                ranking = res.metas.map(function (meta, i) {
                  var rank = i + 1;
                  return {
                    id: "".concat(rank, "-").concat(meta.id),
                    rank: rank,
                    meta: meta
                  };
                });
                return _context.abrupt("return", ranking);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function ranking(_x, _x2, _x3) {
        return _ranking.apply(this, arguments);
      }

      return ranking;
    }()
  }
};